import { useEffect, useRef } from 'react'
import { useLocation } from 'wouter'

import { useIsOpen } from './useIsOpen'

export function usePathChange() {
  const [location] = useLocation()
  const lastPath = useRef<string>(location)
  const [isOpen, toggleOpen] = useIsOpen()

  useEffect(() => {
    if (location === lastPath.current) return

    const isSmall = window.document.body.clientWidth < 768
    lastPath.current = location

    if (isOpen && isSmall) toggleOpen()
  }, [location, isOpen, toggleOpen])
}
